export default __webpack_public_path__ + "static/media/34.41149a81.png";